<template>
    <div ref="chartContainer" class="base-chart" :style="{ width: width, height: height }"></div>
</template>

<script>
export default {
    name: 'BaseChart',
    echartResize: true, // 标记需要响应式处理
    props: {
        options: {
            type: Object,
            required: true,
            default: () => ({})
        },
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '100%'
        },
        theme: {
            type: String,
            default: 'data-screen'
        },
        initOptions: {
            type: Object,
            default: () => ({ renderer: 'canvas' })
        },
        autoResize: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            chartInstance: null
        }
    },
    watch: {
        options: {
            handler(newOptions) {
                this.setOptions(newOptions)
            },
            deep: true
        },
        width() {
            this.handleResize()
        },
        height() {
            this.handleResize()
        }
    },
    mounted() {
        this.initChart()
        if (this.autoResize) {
            this.handleResize()
        }
    },
    beforeDestroy() {
        if (!this.chartInstance) return
        this.chartInstance.dispose()
        this.chartInstance = null
    },
    methods: {
        initChart() {
            if (!this.$refs.chartContainer) return

            // 使用全局注册的 echarts
            this.chartInstance = this.$echarts.init(
                this.$refs.chartContainer,
                this.theme,
                this.initOptions
            )

            this.setOptions(this.options)

            // 监听图表事件
            this.chartInstance.on('click', params => {
                this.$emit('chart-click', params)
            })

            this.chartInstance.on('mouseover', params => {
                this.$emit('chart-mouseover', params)
            })
        },
        setOptions(options) {
            if (!this.chartInstance) return

            // 清除之前可能存在的 loading 状态
            this.chartInstance.hideLoading()

            // 检查是否需要显示 loading
            if (options.loading) {
                this.chartInstance.showLoading({
                    text: '数据加载中...',
                    color: '#2ec7c9',
                    textColor: '#fff',
                    maskColor: 'rgba(0, 0, 0, 0.4)',
                    spinnerRadius: 15,
                    lineWidth: 5,
                    fontSize: 14,
                    ...options.loading
                })
            }

            // 设置图表选项
            this.chartInstance.setOption({
                ...options,
                loading: undefined // 移除 loading 配置
            }, true) // true 表示合并配置，而不是替换
        },
        resize() {
            if (this.chartInstance) {
                this.chartInstance.resize()
            }
        },
        // 获取图表实例，供外部使用
        getChart() {
            return this.chartInstance
        },
        // 显示加载状态
        showLoading(options = {}) {
            if (this.chartInstance) {
                this.chartInstance.showLoading({
                    text: '数据加载中...',
                    color: '#2ec7c9',
                    ...options
                })
            }
        },
        // 隐藏加载状态
        hideLoading() {
            if (this.chartInstance) {
                this.chartInstance.hideLoading()
            }
        }
    }
}
</script>

<style scoped>
.base-chart {
    width: 100%;
    height: 300px;
    /* background: rgba(20, 20, 60, 0.3); */
    border-radius: 4px;
    overflow: hidden;
    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3); */
}
</style>